var map = {
	"app/admin-settings/admin-settings.module": [
		"../../../../../src/app/admin-settings/admin-settings.module.ts",
		"common",
		"admin-settings.module"
	],
	"app/alerts/alerts.module": [
		"../../../../../src/app/alerts/alerts.module.ts",
		"common",
		"alerts.module"
	],
	"app/all-guest-requests/all-guest-requests.module": [
		"../../../../../src/app/all-guest-requests/all-guest-requests.module.ts",
		"common",
		"all-guest-requests.module"
	],
	"app/categories/categories.module": [
		"../../../../../src/app/categories/categories.module.ts",
		"common",
		"categories.module"
	],
	"app/clients/clients.module": [
		"../../../../../src/app/clients/clients.module.ts",
		"common",
		"clients.module"
	],
	"app/dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"app/departments/departments.module": [
		"../../../../../src/app/departments/departments.module.ts",
		"common",
		"departments.module"
	],
	"app/email-templates/email-templates.module": [
		"../../../../../src/app/email-templates/email-templates.module.ts",
		"common",
		"email-templates.module"
	],
	"app/hotel-marketing/hotel-marketing.module": [
		"../../../../../src/app/hotel-marketing/hotel-marketing.module.ts",
		"common",
		"hotel-marketing.module"
	],
	"app/local-attractions-requests/local-attractions-requests.module": [
		"../../../../../src/app/local-attractions-requests/local-attractions-requests.module.ts",
		"common",
		"local-attractions-requests.module"
	],
	"app/logs/logs.module": [
		"../../../../../src/app/logs/logs.module.ts",
		"common",
		"logs.module"
	],
	"app/loyalty-programs/loyalty-programs.module": [
		"../../../../../src/app/loyalty-programs/loyalty-programs.module.ts",
		"common",
		"loyalty-programs.module"
	],
	"app/manage-notifications/manage-notifications.module": [
		"../../../../../src/app/manage-notifications/manage-notifications.module.ts",
		"common",
		"manage-notifications.module"
	],
	"app/modules/modules.module": [
		"../../../../../src/app/modules/modules.module.ts",
		"common",
		"modules.module"
	],
	"app/orders/orders.module": [
		"../../../../../src/app/orders/orders.module.ts",
		"common",
		"orders.module"
	],
	"app/products/products.module": [
		"../../../../../src/app/products/products.module.ts",
		"products.module",
		"common"
	],
	"app/promo-codes/promo-codes.module": [
		"../../../../../src/app/promo-codes/promo-codes.module.ts",
		"common",
		"promo-codes.module"
	],
	"app/questions/questions.module": [
		"../../../../../src/app/questions/questions.module.ts",
		"common",
		"questions.module"
	],
	"app/redemption-logs/redemption-logs.module": [
		"../../../../../src/app/redemption-logs/redemption-logs.module.ts",
		"common",
		"redemption-logs.module"
	],
	"app/roles/roles.module": [
		"../../../../../src/app/roles/roles.module.ts",
		"common",
		"roles.module"
	],
	"app/rooms/rooms.module": [
		"../../../../../src/app/rooms/rooms.module.ts",
		"common",
		"rooms.module"
	],
	"app/staff/staff.module": [
		"../../../../../src/app/staff/staff.module.ts",
		"common",
		"staff.module"
	],
	"app/stay-contacts/stay-contacts.module": [
		"../../../../../src/app/stay-contacts/stay-contacts.module.ts",
		"common",
		"stay-contacts.module"
	],
	"app/theme/theme.module": [
		"../../../../../src/app/theme/theme.module.ts",
		"common",
		"theme.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main